export const onAddEntry = model => ({
  widget: 'entries',
  type: 'onAddEntry',
  payload: { model },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onAddEntry.js